<template>
  <div class="center">
    <!-- 条件筛选框 -->
    <div class="waitingcom_title">
      <!-- 表单 -->
      <el-form
        :model="formLabelAlign"
        ref="formLabelAlign"
        label-width="80px"
        :label-position="labelPosition"
      >
        <el-form-item label="科室名称：">
          <el-input
            v-model.trim="formLabelAlign.departmentName"
            placeholder="请输入科室名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 搜索按钮 -->
      <div class="query_btn">
        <el-button
          @click="handleQuery"
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          >搜索</el-button
        >
        <el-button
          @click="resetQuery"
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          >重置</el-button
        >
      </div>
    </div>

    <!-- 列表全局按钮 -->
    <div class="oper_box">
      <el-button
        v-if="$root.$hasbtn('添加科室')"
        @click="
          pageTitle = '添加科室';
          addDepartment();
        "
        plain
      >
        <i class="iconfont icon-action-add-hover"></i>添加科室</el-button
      >
      <el-button
        v-if="$root.$hasbtn('批量删除科室')"
        @click="batchDeleteInit"
        plain
      >
        <i class="iconfont icon-batch-shanchu"></i>批量删除科室</el-button
      >
      <el-button @click="changeSubject" plain>
        <i class="iconfont icon-batch-shanchu"></i>变更科室申请({{
          changeTotol
        }})</el-button
      >
    </div>

    <!-- 表格内容 -->
    <div class="depart_table" v-loading="loading">
      <el-table
        ref="table"
        :data="getData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        @row-click="stepsListRowClick"
        :row-key="getRowKeyOfTarget"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
        v-loading="isLoading"
      >
        <el-table-column
          type="selection"
          width="60"
          align="center"
          :reserve-selection="true"
        ></el-table-column>

        <el-table-column label="序号" type="index" width="60" align="center"
          ><template slot-scope="scope">
            <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column label="科室名称" align="center">
          <template slot-scope="scope">
            {{ scope.row.DepartmentName }}
          </template>
        </el-table-column>

        <el-table-column label="人数" align="center">
          <template slot-scope="scope">
            {{ scope.row.count }}
          </template>
        </el-table-column>

        <el-table-column label="操作" width="400" align="center">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
                type="text"
                size="small"
                :disabled="currentPage == 1 && scope.$index == 0"
                @click.stop="moveClick(1, scope.row, scope.$index)"
                >上移</el-button
              >
              <el-button
                type="text"
                size="small"
                :disabled="
                  currentPage == pageNum && scope.$index == getData.length - 1
                "
                @click.stop="moveClick(2, scope.row, scope.$index)"
                >下移</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="$root.$hasbtn('编辑')"
                @click.stop="
                  pageVisible = true;
                  isEdit = true;
                  pageTitle = '编辑科室';
                  pageDepartForm.departmentID = scope.row.departmentID;
                  pageDepartForm.departmentName = scope.row.DepartmentName;
                  editorDepartment();
                "
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="$root.$hasbtn('成员管理')"
                @click.stop="
                  rowData = scope.row;
                  membersAdmin();
                "
                >成员管理</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="$root.$hasbtn('删除')"
                @click.stop="
                  hintDialogVisible = true;
                  isDetele = true;
                  hintDialogTitle = '删除科室';
                  hintDialogContent =
                    '确定将名为 ' +
                    scope.row.DepartmentName +
                    ' 的科室删除吗？删除后不可还原';
                  rowData = scope.row;
                  deleteDepartment();
                "
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="foot_box">
      <div class="foot_pagetions">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :page-sizes="pagesizesArr"
          layout="prev, pager, next, sizes, jumper"
          :total="total"
          class="pagination"
        ></el-pagination>
      </div>
    </div>

    <!-- 提示弹窗 -->
    <div class="hintDialogBox">
      <el-dialog
        :title="hintDialogTitle"
        :visible.sync="hintDialogVisible"
        width="30%"
        @closed="hintDialogClosed"
      >
        <span>{{ hintDialogContent }}</span>
        <div slot="footer" class="dialog-footer">
          <el-button @click="hintDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="hintDialogSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 添加/编辑科室页面 -->
    <div class="dialogBox">
      <el-dialog
        :title="pageTitle"
        :visible.sync="pageVisible"
        width="30%"
        @closed="pageDepartClosed"
      >
        <el-form
          :model="pageDepartForm"
          ref="pageDepartForm"
          :rules="pageDepartRules"
          label-width="80px"
          :label-position="pageDepartLabelPosition"
        >
          <el-form-item label="科室ID：" style="display: none">
            <el-input
              v-model.trim="pageDepartForm.departmentID"
              placeholder="请输入科室ID"
            ></el-input>
          </el-form-item>

          <el-form-item label="科室名称：" prop="departmentName">
            <el-input
              v-model.trim="pageDepartForm.departmentName"
              placeholder="请输入科室名称"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="pageVisible = false">取 消</el-button>
          <el-button type="primary" @click="pageDepart">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import systemclass from "@/api/systemclassification";
import loginvuex from "@/store/index";
import departApi from "@/api/depart";
export default {
  props: ["changes"],
  data() {
    // 校验非空
    var validateIsNull = (rule, value, callback, prefixMsg) => {
      if (value instanceof Array) {
        value = value.join("");
      }
      if (value.split(" ").join("").length === 0) {
        callback(new Error(prefixMsg + "不能为空"));
      } else {
        callback();
      }
    };
    return {
      stateArr: [], //存储开始时间和结束时间。
      // 条件筛选框全局定义
      labelPosition: "right",
      formLabelAlign: {
        departmentName: "",
      },
      loading: true,
      // 列表全局按钮定义
      multiple: true,
      // 提示弹窗唤起
      hintDialogVisible: false,
      hintDialogTitle: "",
      hintDialogContent: "",
      isDetele: false,
      isBatchDelete: false,
      // 添加/编辑科室页面定义
      pageVisible: false,
      pageTitle: "",
      pageDepartLabelPosition: "left",
      pageDepartForm: {
        departmentID: "",
        departmentName: "",
      },
      pageDepartRules: {
        departmentName: [
          { required: true, message: "请输入科室名称", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              validateIsNull(rule, value, callback, "科室名称");
            },
            trigger: "blur",
          },
        ],
      },
      isAdd: false,
      isEdit: false,
      // 选中行数据
      rowData: {},
      // 表格内容全局定义
      isLoading: true,
      multipleSelectionIds: [],
      multipleSelection: [],
      multipleSelectionCount: 0,
      getDataCondition: {
        departmentName: "",
      },
      getData: [],
      currentPage: 1,
      pageSize: 10,
      pagesizesArr: [5, 10, 20, 50, 100],
      total: 0,
      pageNum: "",
      changeTotol: 0,
    };
  },
  methods: {
    // 搜索
    handleQuery() {
      this.Buriedpoint(
        { code: "Dept:departList:search", parent_code: "Dept:departList" },
        "statetime"
      );
      this.$refs.table.clearSelection();
      this.currentPage = 1;
      if (this.formLabelAlign.departmentName) {
        this.getDataCondition.departmentName =
          this.formLabelAlign.departmentName;
      } else {
        this.getDataCondition.departmentName = "";
      }
      this.getDepartLists();
    },
    // 获取科室变更总数
    async getDepartWaitList() {
      const obj = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
        pageIndex: 10,
        eachPageNum: 100,
      };
      const { data } = await departApi.departmentWaitList(obj);
      if (data.Status == 200) {
        this.changeTotol = data.Data.count;
      } else {
        this.$message.error(data.Msg);
      }
      console.log(data);
    },
    changeSubject() {
      this.changes(2);
      return
      if(this.changeTotol <=0){
        this.$message({
          message: '警告，当前没有变更科室申请',
          type: 'warning'
        });
      }else{
      this.changes(2);
      }
    },
    // 添加科室
    addDepartment() {
      this.Buriedpoint(
        { code: "Dept:departList:add", parent_code: "Dept:departList" },
        "statetime"
      );
      this.pageVisible = true;
      this.isAdd = true;
    },
    // 编辑
    editorDepartment() {
      this.Buriedpoint(
        { code: "Dept:departList:edit", parent_code: "Dept:departList" },
        "statetime"
      );
    },
    // 删除
    deleteDepartment() {
      this.Buriedpoint(
        { code: "Dept:departList:delete", parent_code: "Dept:departList" },
        "statetime"
      );
    },
    // 成员管理
    membersAdmin() {
      localStorage.setItem("isreload", true);
      this.Buriedpoint({
        code: "Dept:departList:members",
        parent_code: "Dept:departList",
      });
      this.changes(1);
    },
    Buriedpoint(itemt, isstate) {
      if (isstate == "statetime") {
        //次数
        let parmas = {
          type: "2",
          code: itemt.code,
          parent_code: itemt.parent_code,
          stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_time: 1,
          ation_source: null,
          source: "khy",
          ip: null,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        systemclass.addburied(parmas);
      } else {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parmas = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          systemclass.addburied(parmas);
          this.stateArr = [];
        }
      }
    },
    // 重置
    resetQuery() {
      this.Buriedpoint(
        { code: "Dept:departList:rest", parent_code: "Dept:departList" },
        "statetime"
      );
      this.formLabelAlign = {};
      this.$refs.table.clearSelection();
      this.currentPage = 1;
      this.getDataCondition.departmentName = "";
      this.loading = true;
      this.getDepartLists();
    },
    // 基本请求参数工具
    baseReqParamUtils(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },
    // 获取科室列表
    async getDepartLists() {
      this.getDepartWaitList();
      this.isLoading = true;
      const reqParam = this.baseReqParamUtils(new Object());
      reqParam.pageIndex = this.currentPage - 1;
      reqParam.eachPageNum = this.pageSize;

      reqParam.seekName = this.getDataCondition.departmentName;

      // console.log(reqParam, "获取科室列表请求数据");
      const { data } = await departApi.getDepartList(reqParam);
      // console.log(data, "获取科室列表返回数据");
      if (data.Status == 200) {
        this.getData = data.Data.data;
        this.total = data.Data.count;
        this.isLoading = false;
        this.pageNum = Math.ceil(this.total / this.pageSize);
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else {
        this.isLoading = false;
        this.loading = false;
        this.$message.error(data.Msg);
      }
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 表格多选框改变时触发
    handleSelectionChange(rows) {
      // 初始化全局表格多选框
      this.multipleSelectionIds = [];
      this.multipleSelection = [];
      this.multipleSelectionCount = 0;
      // 将数据存入
      rows.forEach((row) => {
        this.multipleSelectionIds.push(row.departmentID);
      });
      this.multipleSelection = rows;
      this.multipleSelectionCount = this.multipleSelection.length;
      // 全局按钮样式配置
      this.multiple = !this.multipleSelection.length;
    },
    // 勾选当前行激活check
    stepsListRowClick(row, column, event) {
      this.$refs.table.toggleRowSelection(row);
    },
    // 给每一行设置key
    getRowKeyOfTarget(row) {
      return row.departmentID;
    },
    // 每页大小改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.loading = true;
      this.getDepartLists();
    },
    // 切换页数后触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.loading = true;
      this.getDepartLists();
    },
    // 批量删除初始化
    batchDeleteInit() {
      this.Buriedpoint(
        { code: "Dept:departList:batchDelete", parent_code: "Dept:departList" },
        "statetime"
      );
      if (this.multipleSelection.length < 1) {
        this.$message.warning("请选择要移除的科室");
        return;
      }
      this.hintDialogVisible = true;
      this.isBatchDelete = true;
      this.hintDialogTitle = "批量删除科室";
      this.hintDialogContent = "确定要将选定科室批量删除吗？删除后不可还原";
    },
    // 提示弹窗关闭触发
    hintDialogClosed() {
      this.isDetele = false;
      this.isBatchDelete = false;
    },
    // 提示弹窗提交按钮
    async hintDialogSubmit() {
      // 删除科室
      if (this.isDetele) {
        console.log("删除科室...");
        const reqParam = this.baseReqParamUtils(new Object());
        reqParam.departmentID = this.rowData.departmentID;
        console.log(reqParam, "删除科室请求数据");
        const { data } = await departApi.deleteSection(reqParam);
        console.log(data, "删除科室返回数据");
        if (data.Status == 200) {
          this.hintDialogVisible = false;
          this.$message.success("删除科室成功");
          this.getDepartLists();
        } else {
          this.$message.error(data.Data);
        }
      }

      // 批量删除科室
      if (this.isBatchDelete) {
        console.log("批量删除科室...");
        const reqParam = this.baseReqParamUtils(new Object());
        reqParam.departmentIDArr = `[${this.multipleSelectionIds}]`;
        console.log(reqParam, "批量删除科室请求数据");
        const { data } = await departApi.deleteSectionBatch(reqParam);
        console.log(data, "批量删除科室返回数据");
        if (data.Status == 200) {
          this.hintDialogVisible = false;
          this.$message.success("批量删除科室成功");
          this.getDepartLists();
          this.$refs.table.clearSelection();
        } else {
          this.$message.error(data.Data);
        }
      }
    },
    // 添加科室页面关闭时调用
    pageDepartClosed() {
      this.$refs.pageDepartForm.resetFields();
      this.pageDepartForm.departmentID = "";
      this.pageDepartForm.departmentName = "";
      this.isAdd = false;
      this.isEdit = false;
    },
    // 添加/编辑科室
    pageDepart() {
      this.$refs.pageDepartForm.validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            console.log("添加科室...");
            this.createSections();
          }
          if (this.isEdit) {
            console.log("编辑科室...");
            this.edits();
          }
        } else {
          return false;
        }
      });
    },
    // 添加科室接口调用
    async createSections() {
      const reqParam = this.baseReqParamUtils(new Object());
      reqParam.departmentName = this.pageDepartForm.departmentName;
      const { data } = await departApi.createSection(reqParam);
      console.log(data, "添加科室返回数据");
      if (data.Status == 200) {
        this.pageVisible = false;
        this.currentPage = 1;
        this.getDepartLists();
        this.$message.success("添加科室成功");
      } else {
        this.$message.error(data.Data);
      }
    },
    // 编辑科室接口调用
    async edits() {
      const reqParam = this.baseReqParamUtils(new Object());
      reqParam.departmentID = this.pageDepartForm.departmentID;
      reqParam.departmentName = this.pageDepartForm.departmentName;
      console.log(reqParam, "编辑科室请求数据");
      const { data } = await departApi.edit(reqParam);
      console.log(data, "编辑科室返回数据");
      if (data.Status == 200) {
        this.pageVisible = false;
        this.getDepartLists();
        this.$message.success("编辑科室成功");
      } else {
        this.$message.error(data.Data);
      }
    },
    // 上移下移
    moveClick(type, row, index) {
      let obj = {
        switchID: "", // 需要交换的科室ID
        currentID: row.departmentID, // 当前科室ID
        hid: JSON.parse(loginvuex.state.hid),
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
      };
      if (type == 1) {
        // 上移
        obj.switchID = this.getData[index - 1].departmentID;
      } else {
        // 下移
        obj.switchID = this.getData[index + 1].departmentID;
      }
      this.$confirm(
        `此操作将科室名称为${row.DepartmentName}${
          type == 1 ? "上移" : "下移"
        }, 是否继续?`,
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          this.$message({
            type: "success",
            message: `${type == 1 ? "上移" : "下移"}成功`,
          });
          const { data } = await departApi.switchManageSection(obj);
          if (data.Status == 200) {
            this.getDepartLists(); // 刷新列表
          } else {
            this.$message.error(data.Data);
          }
          console.log(data);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
  activated() {
    this.getDepartLists();
  },
  created() {
    this.stateArr = [];
    localStorage.removeItem("isreload");
  },
};
</script>

<style lang='scss' scoped>
// 右边整体iframe的css
.center {
  height: 100%;
  width: 100%;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}

// 条件筛选框css
.waitingcom_title {
  height: 81px;
  padding: 24px 24px 16px 10px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  ::v-deep .el-form-item__label {
    margin-left: 24px;
    min-width: 87px !important;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .el-form {
    display: flex;
    ::v-deep .el-form-item__content {
      margin-left: 120px !important;
    }
    ::v-deep .el-input > .el-input__inner {
      width: 168px;
    }
  }
  .query_btn {
    margin: 0;
    display: flex;
    .el-button {
      width: 88px;
      height: 40px;
      margin-left: 24px;
    }
  }
}

// 列表全局按钮css
.oper_box {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 88px;
  height: 40px;
  opacity: 1;
  padding: 0px 24px !important;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    background: #1890ff;
    width: 104px;
    margin-left: 0px;
    margin-right: 24px;
  }
  .el-button:nth-child(2) {
    background: #e54d4d;
    width: 136px;
    margin-left: 0px;
    margin-right: 24px;
    span > i {
      font-size: 16px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(3) {
    background: #1890ff;
    width: 150px;
    margin-left: 0px;
    margin-right: 24px;
  }
}

::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

// dialog弹窗css
.dialogBox {
  // dialog整体样式
  ::v-deep .el-dialog {
    width: 537px;
    height: 297px;
    border-radius: 5px 5px 5px 5px;
    background: #ffffff;
    opacity: 1;
    // 弹框头部样式
    .el-dialog__header {
      height: 60px;
      background: linear-gradient(
        180deg,
        #64b5ff 0%,
        rgba(199, 228, 255, 1) 100%
      );
      opacity: 1;
      border-radius: 5px 5px 0px 0px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
    }
    // 弹框身体样式
    .el-dialog__body {
      .el-form {
        display: flex;
        flex-direction: column;
        .el-form-item {
          display: flex;
          justify-content: center;
          .el-form-item__label {
            min-width: 98px !important;
            height: 40px;
            font-size: 15px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 40px;
            color: #333333;
            opacity: 1;
          }
          .el-form-item__content {
            margin-left: 0px !important;
            .el-input__inner {
              width: 380px;
              height: 40px;
              background: #ffffff;
              border: 1px solid #d9d9d9;
              opacity: 1;
              border-radius: 4px;
            }
          }
        }
      }
    }
    // 弹框底部样式
    .dialog-footer {
      text-align: center;
      .el-button {
        margin-right: 50px;
      }
      .el-button:nth-child(1) {
        background: #eeeeee;
        opacity: 1;
        border-radius: 4px;
      }
      .el-button:nth-child(2) {
        background: #1890ff;
        opacity: 1;
        border-radius: 4px;
      }
    }
  }
}

// dialog提示弹窗css
.hintDialogBox {
  // dialog整体样式
  ::v-deep .el-dialog {
    width: 421px !important;
    height: 211px;
    border-radius: 5px 5px 5px 5px;
    background: #ffffff;
    opacity: 1;
    // 弹框头部样式
    .el-dialog__header {
      height: 60px;
      background: linear-gradient(
        180deg,
        #64b5ff 0%,
        rgba(199, 228, 255, 1) 100%
      );
      opacity: 1;
      border-radius: 5px 5px 0px 0px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
    }
    // 弹框身体样式
    .el-dialog__body {
      text-align: center;
    }
    // 弹框底部样式
    .dialog-footer {
      text-align: center;
      .el-button {
        margin-right: 50px;
      }
      .el-button:nth-child(1) {
        background: #eeeeee;
        opacity: 1;
        border-radius: 4px;
      }
      .el-button:nth-child(2) {
        background: #1890ff;
        opacity: 1;
        border-radius: 4px;
      }
    }
  }
}

// 表格内容css
.depart_table {
  margin-top: 24px;
  padding: 0px 24px;
  min-height: 560px;
}

::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}

.operation_box {
  text-align: center;
  margin: 0 auto;
  .el-button {
    font-size: 16px;
    margin-left: 0px;
    margin-right: 25px;
  }
}

::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}

// 分页
.foot_box {
  position: relative;
  height: 88px;
  .foot_pagetions {
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 30px;
    span {
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      b {
        color: #ff0000;
      }
    }
    .pagination {
      ::v-deep .el-pager {
        li {
          border: 1px solid #d9d9d9;
          margin-right: 8px;
          &.active {
            color: #ffffff;
            background-color: #409eff;
            border: none;
          }
        }
      }
      ::v-deep .el-pagination__jump {
        margin: 0px 10px 0px 0px !important;
      }
    }
  }
}
</style>